<template>
  <div>
    <modal :show.sync="show" modalClasses="modal-lg">
      <div class="row">
        <div class="col-md-12">
          <div class="video-modal-header text-center">
            <div class="text-center w-100 pl-2 pr-2" id="file-input">
              <label v-if="!uploadingVideo">
                <input type="file" accept="video/mp4" @change="onFileChanged" />
                <span class="btn btn-sm btn-upload">Upload a Video</span>
              </label>
              <base-progress
                v-if="uploadingVideo && uploadPercentage < 100"
                type="primary"
                :height="8"
                :value="uploadPercentage"
                label="Uploading . . ."
              ></base-progress>
              <div
                v-if="uploadPercentage === 100"
                class="spinner-border text-primary"
                role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 mt-4">
          <div class="row">
            <div class="col-md-4 mb-4" v-for="video in videos" :key="video.url">
              <div class="video">
                <img
                  :src="video.thumbnail ?  video.thumbnail : require('@/assets/default_live_stream_thumbnail.jpg')"
                  class="img-thumbnail"
                  alt
                  @click="onVideoSelected(video)"
                />
                <p
                  v-if="selectedVideoUrl === video.url && selectedVideoStatus === 'in_progress'"
                  class="mt-3 text-center mb-0 text-warning"
                >Video is under review</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <template slot="footer">
        <div class="col-md-12" align="right">
          <base-button outline type="primary" class="btn-cancel" @click="closeModal">Cancel</base-button>
        </div>
      </template>
    </modal>
  </div>
</template>
<script>
export default {
  name: 'video-upload-modal',
  props: {
    show: true,
    uploadingVideo: Boolean,
    onFileChanged: Function,
    uploadPercentage: Number,
    videos: Array,
    closeModal: Function,
    onVideoSelected: Function,
    selectedVideoUrl: String,
    selectedVideoStatus: String
  },
  data() {
    return {
      showClose: this.show
    }
  }
}
</script>
<style  scoped>
.video-modal-header {
  /* min-height: 211px; */
  padding-top: 5rem;
  padding-bottom: 5rem;
  border-style: dashed;
  border-width: 1px;
  border-radius: 5px;
}
.btn-upload {
  cursor: pointer;
  font-size: 14px;
  font-weight: normal;
  color: rgb(66, 82, 110) !important;
  border-width: 0px;
  text-decoration: none;
  background: rgba(9, 30, 66, 0.04);
  border-radius: 5px;
  padding: 0px 8px;
  transition: background 0.1s ease-out 0s,
    box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s;
  outline: none !important;
  padding: 15px 20px;
}

.btn-upload:hover,
.btn-upload:focus,
.btn-upload:active {
  box-shadow: none !important;
}

.video {
  cursor: pointer;
  transition: 1s;
}
.video:hover {
  transform: scale(1.1, 1.1);
}
</style>
